import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiInformationOutline } from "@mdi/js";

const InfoTooltip = ({
  text,
  placement = "bottom",
  iconSize = "16px",
  iconClassName = "",
  className = "",
  delay = null,
  container = null,
  style = null,
}) => {
  const overlayProps = {
    placement,
    overlay: (
      <Tooltip className={className}>
        {text}
      </Tooltip>
    ),
  };

  if (delay != null) {
    overlayProps.delay = delay;
  }

  if (container) {
    overlayProps.container = container;
  }

  return (
    <OverlayTrigger {...overlayProps}>
      <span style={{ cursor: "help", ...style }}>
        <Icon
          path={mdiInformationOutline}
          size={iconSize}
          className={iconClassName || undefined}
          aria-hidden="true"
        />
      </span>
    </OverlayTrigger>
  );
};

export default InfoTooltip;
